const globalDefaults = {};

interface GlobalConfig {
  googleMapsApiKey: string;
  restAPIUrl: string;
  oncallAPIUrl: string;
  env: 'local'|'development'|'testing'|'staging'|'production';
  useMdmIds: boolean,
}

const allConfigs:{
  localhost: GlobalConfig,
  dev: GlobalConfig,
  test: GlobalConfig,
  staging: GlobalConfig
  prod: GlobalConfig,
} = {
  localhost: {
    ...globalDefaults,
    googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk',
    restAPIUrl: 'https://api.core-profile-dev.misp-solutions.com/spp',
    oncallAPIUrl: 'https://apigateway.oncall-dev.misp-solutions.com/virtual-assistant',
    env: 'local',
    useMdmIds: true,
  },
  dev: {
    ...globalDefaults,
    googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk',
    restAPIUrl: 'https://api.core-profile-dev.misp-solutions.com/spp',
    oncallAPIUrl: 'https://apigateway.oncall-dev.misp-solutions.com/virtual-assistant',
    env: 'development',
    useMdmIds: true,
  },
  test: {
    ...globalDefaults,
    googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk',
    restAPIUrl: 'https://api.core-profile-test.misp-solutions.com/spp',
    oncallAPIUrl: 'https://apigateway.oncall-test.misp-solutions.com/virtual-assistant',
    env: 'testing',
    useMdmIds: true,
  },
  staging: {
    ...globalDefaults,
    googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk',
    restAPIUrl: 'https://api.core-profile-staging.misp-solutions.com/spp',
    oncallAPIUrl: 'https://apigateway.oncall-staging.misp-solutions.com/virtual-assistant',
    env: 'staging',
    useMdmIds: true,
  },
  prod: {
    ...globalDefaults,
    googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk',
    restAPIUrl: 'https://api.core-profile.misp-solutions.com/spp',
    oncallAPIUrl: 'https://apigateway.oncall-prod.misp-solutions.com/virtual-assistant',
    env: 'production',
    useMdmIds: true,
  },
};

// eslint-disable-next-line import/no-mutable-exports
let config: GlobalConfig;
if (window.location.hostname.includes('localhost') || window.location.hostname.includes('.chaos')) {
  config = allConfigs.localhost;
} else if (window.location.hostname.includes('-dev.')) {
  config = allConfigs.dev;
} else if (window.location.hostname.includes('-test.')) {
  config = allConfigs.test;
} else if (window.location.hostname.includes('-staging.')) {
  config = allConfigs.staging;
} else {
  config = allConfigs.prod;
}

export default config;
